import { useEffect, useState } from "react"
import { mappings_locations_path } from "~/lib/routes"
import { LocationsMappingsType } from "~/react/components/search/filters"

export const useLocationMappings = (): LocationsMappingsType => {
  const [locationMappings, setLocationMappings] = useState<LocationsMappingsType>({
    continents: [],
    business_regions: [],
  })

  useEffect(() => {
    const fetchLocationMappings = async () => {
      try {
        const response = await fetch(mappings_locations_path())
        const data = await response.json()
        setLocationMappings(data)
      } catch (error) {
        // Silently fail - keep initial empty state
        console.error("Failed to fetch location mappings:", error)
      }
    }
    fetchLocationMappings()
  }, [])

  return locationMappings
}
